export const iconFontAwesomeCommunicationMicrophone = (
	<i className="fa-solid fa-microphone"></i>
);
